function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.625,15.441a.381.381,0,0,1-.431-.431V7.252a.381.381,0,0,1,.431-.431h.862a.381.381,0,0,1,.431.431V15.01a.381.381,0,0,1-.431.431Zm5.89-12.068a.553.553,0,0,1,.575.575v.575a.553.553,0,0,1-.575.575h-.575V17.165a1.717,1.717,0,0,1-1.724,1.724H2.873a1.663,1.663,0,0,1-1.221-.5,1.663,1.663,0,0,1-.5-1.221V5.1H.575A.553.553,0,0,1,0,4.523V3.948a.553.553,0,0,1,.575-.575H3.52L4.741,1.326A1.651,1.651,0,0,1,6.249.5H9.841a1.651,1.651,0,0,1,1.508.826L12.57,3.373ZM6.177,2.332,5.531,3.373h5.028L9.913,2.332a.211.211,0,0,0-.18-.108H6.357A.211.211,0,0,0,6.177,2.332Zm7.039,14.833V5.1H2.873V17.165ZM5.6,15.441a.381.381,0,0,1-.431-.431V7.252A.381.381,0,0,1,5.6,6.821h.862a.381.381,0,0,1,.431.431V15.01a.381.381,0,0,1-.431.431Z",
  transform: "translate(0 -0.5)",
  fill: "#ee2375"
});

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.09,
    height: 18.389,
    viewBox: "0 0 16.09 18.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.20fc085d.svg";
export { ForwardRef as ReactComponent };